<div style="overflow-y:auto; height: 100%; padding-right: 24px; overflow-x:hidden;">
    <nz-divider nzText="Khen thưởng - kỷ luật" nzOrientation="left" nzPlain ></nz-divider>
    <span>Quá trình khen thưởng</span>
    <nz-table class="w-full" #basicTable [nzData]="listOfData" [nzScroll]="{x: '1500px'}">
      <thead>
        <tr>
          <th>STT</th>
          <th>Hình thức</th>
          <th>Lý do</th>
          <th>Cấp khen thưởng</th>
          <th>Người ký</th>
          <th>Ngày ký</th>
          <th>Số QĐ</th>
          <th>Ngày QĐ</th>
          <th>Ngày hiệu lực</th>
          <th>Ghi chú</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data; let i = index;">
          <td>{{ i+1 }}</td>
          <td>{{ data.sqd }}</td>
          <td>{{ data.nqd }}</td>
          <td>{{ data.nhl }}</td>
          <td>{{ data.nqd }}</td>
          <td>{{ data.nqd }}</td>
          <td>{{ data.bac }}</td>
          <td>{{ data.heso }}</td>
          <td>{{ data.nqd }}</td>
          <td></td>
        </tr>
      </tbody>
    </nz-table>
    <nz-divider></nz-divider>
    <span>Quá trình kỷ luật</span>
      <nz-table [nzData]="listOfData" class="w-full" [nzScroll]="{x: '1500px'}" #basicTable>
        <thead>
          <tr>
            <th>STT</th>
            <th>Hình thức</th>
            <th>Lý do</th>
            <th>Cấp khen thưởng</th>
            <th>Người ký</th>
            <th>Ngày ký</th>
            <th>Số QĐ</th>
            <th>Ngày QĐ</th>
            <th>Ngày hiệu lực</th>
            <th>Ghi chú</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of basicTable.data; let i = index;">
            <td>{{ i+1 }}</td>
            <td>{{ data.sqd }}</td>
            <td>{{ data.nqd }}</td>
            <td>{{ data.nhl }}</td>
            <td>{{ data.nqd }}</td>
            <td>{{ data.nqd }}</td>
            <td>{{ data.bac }}</td>
            <td>{{ data.heso }}</td>
            <td>{{ data.nqd }}</td>
            <td></td>
          </tr>
        </tbody>
      </nz-table>
</div>